// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

#SplashScreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(45deg, #ddd 5%, #fff 10%, #eee 30%, #fff 50%, #ddd 70%, #fff 80%, #eee 95%);
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.center {
  position: absolute;
  width: 50vw;
  height: 50vw;
  background-color: transparent;
  border-radius: 50%;
}

.bottomTab {
  display: flex;
  flex-direction: column;
  gap: 2vw;
  position: fixed;
  z-index: 1000;
  bottom: 0vw;
  left: 0;
  width: 100vw;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  pointer-events: auto;
  transform: translateY(0);
  opacity: 1;
  height: 15vh;
}

.hiddenBlur {
  opacity: 0;
  pointer-events: none;
  transform: translateY(20vh);
}

ion-router-outlet {
  z-index: 2;
}

.smallBlurrer2 {
  height: calc(20vw + env(safe-area-inset-bottom) + 0vh);
}

.bigBlurrer2 {
  height: calc(20vw + env(safe-area-inset-bottom) + 4vh);
}

.smallBlurrer {
  height: calc(20vw + env(safe-area-inset-bottom));
  pointer-events: none;
}

.bigBlurrer {
  height: calc(20vw + env(safe-area-inset-bottom));
  pointer-events: none;
}

.tabMain {
  z-index: 1000;
}

.appBgHeader {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 0;
  background: linear-gradient(180deg, hsl(var(--drop-color-primary)/1) 0%, hsl(var(--drop-color-primary)/0.8) 20%, hsl(var(--drop-color-primary)/0.6) 23%, hsl(var(--drop-color-primary)/0.3) 26%, hsl(var(--drop-bareLight-white)/0.6) 29%, hsl(var(--drop-bareLight-white)/0.3) 32%, hsl(var(--drop-bareLight-white)/0) 41%, hsl(var(--drop-bareLight-white)/0) 90%, hsl(var(--drop-bareLight-white)/0) 100%);
  transition: all 0.6s ease-in-out;
  background-repeat: no-repeat;
  background-color: hsl(var(--drop-bareLight-white)/1);
}

.smallHead {
  background-position: 0 35%;
  background-size: 300% 300%;
}

.bigHead {
  background-position: 0 25%;
  background-size: 300% 300%;
}

.regularHead {
  background-position: 0 100%;
  background-size: 300% 300%;
}

.biggerHead {
  background-position: 0 20%;
  background-size: 300% 400%;
}

.smallerHead {
  background-position: 0 40%;
  background-size: 300% 300%;
}

.tinyHead {
  background-position: 0 37%;
  background-size: 300% 300%;
}

.calendarHead {
  background-position: 0 10%;
  background-size: 300% 200%;
}

.menuHead {
  background-position: 0 25%;
  background-size: 300% 175%;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACC,SAAA;EACA,UAAA;AACD;;AAEA;EACC,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EAEA,uGAAA;EAQA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAPD;;AAUA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AAPD;;AAUA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EAEA,mBAAA;EACA,uBAAA;EACA,gCAAA;EAEA,oBAAA;EAEA,wBAAA;EACA,UAAA;EACA,YAAA;AAVD;;AAmCA;EACC,UAAA;EACA,oBAAA;EACA,2BAAA;AAhCD;;AAmCA;EACC,UAAA;AAhCD;;AA2CA;EACC,sDAAA;AAxCD;;AA2CA;EACC,sDAAA;AAxCD;;AA2CA;EACC,gDAAA;EACA,oBAAA;AAxCD;;AA2CA;EACC,gDAAA;EACA,oBAAA;AAxCD;;AA6EA;EACC,aAAA;AA1ED;;AA6EA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,6YAAA;EAoBA,gCAAA;EACA,4BAAA;EACA,oDAAA;AA7FD;;AAkGA;EACC,0BAAA;EACA,0BAAA;AA/FD;;AAkGA;EACC,0BAAA;EACA,0BAAA;AA/FD;;AAkGA;EACC,2BAAA;EACA,0BAAA;AA/FD;;AAkGA;EACC,0BAAA;EACA,0BAAA;AA/FD;;AAkGA;EACC,0BAAA;EACA,0BAAA;AA/FD;;AAkGA;EACC,0BAAA;EACA,0BAAA;AA/FD;;AAkGA;EAGC,0BAAA;EACA,0BAAA;AAjGD;;AAoGA;EACC,0BAAA;EACA,0BAAA;AAjGD","sourcesContent":["* {\n\tmargin: 0;\n\tpadding: 0;\n}\n\n#SplashScreen {\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: 1000;\n\twidth: 100%;\n\t// background-color: #fff;\n\tbackground: linear-gradient(45deg,\n\t\t\t#ddd 5%,\n\t\t\t#fff 10%,\n\t\t\t#eee 30%,\n\t\t\t#fff 50%,\n\t\t\t#ddd 70%,\n\t\t\t#fff 80%,\n\t\t\t#eee 95%);\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n.center {\n\tposition: absolute;\n\twidth: 50vw;\n\theight: 50vw;\n\tbackground-color: transparent;\n\tborder-radius: 50%;\n}\n\n.bottomTab {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2vw;\n\tposition: fixed;\n\tz-index: 1000;\n\tbottom: 0vw;\n\tleft: 0;\n\twidth: 100vw;\n\t// height: 16vw;\n\talign-items: center;\n\tjustify-content: center;\n\ttransition: all 0.3s ease-in-out;\n\t// padding-bottom:calc(env(safe-area-inset-bottom) * 2);\n\tpointer-events: auto;\n\t// transform: translateY(-70vh);\n\ttransform: translateY(0);\n\topacity: 1;\n\theight: 15vh;\n\t// background-color: var(--ion-white-primary);\n}\n\n.blurrer {\n\t//   background: linear-gradient(0deg, var(--ion-pass-primary) 0%, var(--ion-pass-primary) 50%, var(--ion-pass-primary) 100%);\n\t//   background-size: 200% 200%;\n\t//   background-position: 0% 0%;\n\t//   background: var(--ion-white-grey);\n\t//  transform: translateY(0);\n\t// opacity: 1;\n\t// \ttransition: all 0.3s ease-in-out;\n\t//     backdrop-filter: blur(50px);\n\t//     width: 100vw;\n\t//     display: block;\n\t//     position: fixed;\n\t//     bottom: 0vw;\n\t//     left: 0;\n\t//     // box-shadow: 0 -13vw 15vw 5vw var(--ion-text-primary) inset;\n\t//     z-index: 1000;\n\t//     -webkit-backdrop-filter: blur(50px);\n\t//     mask-image: linear-gradient(to top, black 0%, rgba(0, 0, 0, 0.9) 60%, transparent 100%);\n\t//     -webkit-mask-image: linear-gradient(to top, black 0%, rgba(0, 0, 0, 0.9) 60%, transparent 100%);\n}\n\n.hiddenBlur {\n\topacity: 0;\n\tpointer-events: none;\n\ttransform: translateY(20vh);\n}\n\nion-router-outlet {\n\tz-index: 2;\n}\n\n.smallTab {\n\t// height: calc(20vw + (env(safe-area-inset-bottom)/4) + 2vh);\n}\n\n.fullTab {\n\t// height: calc(20vw + (env(safe-area-inset-bottom)/4) + 6vh);\n}\n\n.smallBlurrer2 {\n\theight: calc(20vw + env(safe-area-inset-bottom) + 0vh);\n}\n\n.bigBlurrer2 {\n\theight: calc(20vw + env(safe-area-inset-bottom) + 4vh);\n}\n\n.smallBlurrer {\n\theight: calc(20vw + env(safe-area-inset-bottom));\n\tpointer-events: none;\n}\n\n.bigBlurrer {\n\theight: calc(20vw + env(safe-area-inset-bottom));\n\tpointer-events: none;\n}\n\n// .topMacros{\n// \tbackground: linear-gradient(0deg, var(--ion-color-primary) 0%, var(--ion-half-primary) 50%, var(--ion-pass-primary) 100%);\n// \tbackground-size: 200% 200%;\n// border-radius: 30px;\n// \tz-index: 1000;\n// \theight: 0;\n// \topacity: 0;\n// \twidth: 0;\n// \tpointer-events: none;\n// \ttransition: all 0.3s ease-in-out;\n// \tdisplay: flex;\n// \talign-items: center;\n// \tjustify-content: flex-start;\n//     margin: 0 auto 0 4vw;\n// }\n// .showMacros{\n\n// background-position: 0% 50%;\n// \twidth: 72vw;\n// \topacity: 1;\n// \theight: 4vh;\n// \tbackdrop-filter: blur(20px);\n// \ttransform: translateY(0);\n\n// }\n// .hideMacros{\n//   background-position: 0% 50%;\n// \tborder-radius: 10px;\n// \twidth: 30vw;\n// \topacity: 0;\n// \theight: 0;\n// \tbackdrop-filter: blur(20px);\n// \ttransform: translateY(10vw);\n// }\n.tabMain {\n\tz-index: 1000;\n}\n\n.appBgHeader {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\theight: 100vh;\n\twidth: 100vw;\n\tz-index: 0;\n\tbackground: linear-gradient(180deg, hsl(var(--drop-color-primary)/1) 0%, hsl(var(--drop-color-primary)/0.8) 20%,\n\t\t\thsl(var(--drop-color-primary)/0.6) 23%,\n\t\t\thsl(var(--drop-color-primary)/0.3) 26%,\n\t\t\thsl(var(--drop-bareLight-white)/0.6) 29%,\n\t\t\thsl(var(--drop-bareLight-white)/0.3) 32%,\n\t\t\thsl(var(--drop-bareLight-white)/0) 41%,\n\t\t\thsl(var(--drop-bareLight-white)/0) 90%,\n\t\t\thsl(var(--drop-bareLight-white)/0) 100%);\n\t// background: linear-gradient(180deg, hsl(var(--drop-color-primary)/1) 0%,\n\t// hsl(var(--drop-color-primary)/1) 10%,\n\t// hsl(var(--drop-color-primary)/1) 20%,\n\t// hsl(var(--drop-color-primary)/0.9) 30%,\n\t// hsl(var(--drop-color-primary)/0.6) 40%,\n\t// hsl(var(--drop-color-primary)/0.3) 50%,\n\t// hsl(var(--drop-bareLight-white)/0.3) 60%,\n\t// hsl(var(--drop-bareLight-white)/0.6) 70%,\n\t// hsl(var(--drop-bareLight-white)/0.3) 80%, \n\t// hsl(var(--drop-bareLight-white)/0) 90%, \n\t// hsl(var(--drop-bareLight-white)/0) 100%);\n\t// background: linear-gradient(180deg, var(--ion-color-primary) 0%, var(--ion-half-primary) 6%, hsl(var(--drop-bareLight-primary) / 1) 12%, hsl(var(--drop-bareLight-white) / 1) 100%);\n\ttransition: all 0.6s ease-in-out;\n\tbackground-repeat: no-repeat;\n\tbackground-color: hsl(var(--drop-bareLight-white)/1);\n\t// background-position: 0 100%;\n\n}\n\n.smallHead {\n\tbackground-position: 0 35%;\n\tbackground-size: 300% 300%;\n}\n\n.bigHead {\n\tbackground-position: 0 25%;\n\tbackground-size: 300% 300%;\n}\n\n.regularHead {\n\tbackground-position: 0 100%;\n\tbackground-size: 300% 300%;\n}\n\n.biggerHead {\n\tbackground-position: 0 20%;\n\tbackground-size: 300% 400%;\n}\n\n.smallerHead {\n\tbackground-position: 0 40%;\n\tbackground-size: 300% 300%;\n}\n\n.tinyHead {\n\tbackground-position: 0 37%;\n\tbackground-size: 300% 300%;\n}\n\n.calendarHead {\n\t// background-position: 0 -20%;\n\t// background-size: 300% 300%;\n\tbackground-position: 0 10%;\n\tbackground-size: 300% 200%;\n}\n\n.menuHead {\n\tbackground-position: 0 25%;\n\tbackground-size: 300% 175%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
